import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {
  Button,
  Chip,
  Container,
  Grid,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import { Navigate, useParams } from 'react-router';
import { DetailsHeader } from './components/details-header';
import { OfferProvider } from './context/offer';
import { ContentBox } from '@/components/shared/content-box';
import { MarkdownRenderer } from '@/components/shared/markdown-renderer';
import { useCourseDetails } from '@/data/catalog/course';
import { useSetTitle } from '@/hooks/use-set-title';

const DetailsSkeleton = () => {
  return (
    <Stack spacing={2}>
      <Skeleton
        width="100%"
        height={500}
        sx={{ transformOrigin: '0 !important', transform: 'none' }}
      />
      <Container maxWidth="lg" sx={{ m: '24px auto !important' }}>
        <Skeleton
          width="50%"
          sx={{ transformOrigin: '0 !important', transform: 'none' }}
        />
        <Skeleton
          width="70%"
          sx={{ transformOrigin: '0 !important', transform: 'none', mt: 2 }}
        />
      </Container>
    </Stack>
  );
};

export const Details = () => {
  const { id } = useParams();
  const { details, isLoading } = useCourseDetails(Number(id));
  useSetTitle(details?.course.name ?? '');

  const course = details?.course;
  const institution = details?.institution;

  if (isLoading) return <DetailsSkeleton />;

  if (!course || !institution)
    return <Navigate to="/cursos/curso-nao-encontrado" />;

  return (
    <OfferProvider>
      <DetailsHeader course={course} institution={institution} />
      <Container maxWidth="lg">
        <Grid container>
          <Grid size={{ xs: 12, md: 8 }} mt={4} mb={8} gap={2}>
            <Stack spacing={6}>
              <Stack gap={2}>
                <Typography variant="h2">Sobre o curso</Typography>
                {course?.course_program && (
                  <Button
                    variant="outlined"
                    startIcon={<OpenInNewIcon />}
                    onClick={() => {
                      window.open(
                        course?.course_program ?? '',
                        '_blank',
                        'noopener'
                      );
                    }}
                  >
                    Acessar informações completas do curso
                  </Button>
                )}
                <MarkdownRenderer markdown={course.about} />
              </Stack>
              {course?.skills?.length > 0 && (
                <ContentBox gap={2}>
                  <Typography variant="h2">
                    Habilidades desenvolvidas
                  </Typography>
                  <Stack direction="row" flexWrap="wrap" gap={1}>
                    {course?.skills?.map((skill) => (
                      <Chip key={skill} label={skill} />
                    ))}
                  </Stack>
                </ContentBox>
              )}
              {institution?.about && (
                <Stack gap={2}>
                  <Typography variant="h2">
                    Sobre a {institution.name}
                  </Typography>
                  <MarkdownRenderer markdown={institution?.about} />
                </Stack>
              )}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </OfferProvider>
  );
};
